$(function() {
  const free_shipping_threshold_eu = 50;
  const shipping_cost_eu = 595; // €5.95

  const free_shipping_threshold_au = 100;
  const free_shipping_threshold_ca = 100;
  const shipping_cost_au = 9.00;
  const shipping_cost_ca = 8.00;

  const free_shipping_threshold_pl = 215; // Poland
  const shipping_cost_pl = 13.00;        // Poland

  let refreshTimer1 = null;
  let refreshTimer2 = null;

  function refreshCartSoon() {
    clearTimeout(refreshTimer1);
    clearTimeout(refreshTimer2);

    refreshCart();
    refreshTimer1 = setTimeout(refreshCart, 150);
    refreshTimer2 = setTimeout(refreshCart, 400);
  }

  function catchRequest() {
    var originalFetch = window.fetch;

    window.fetch = function() {
      const request = originalFetch.apply(window, arguments);

      const url = arguments[0];
      const urlString = typeof url === 'string' ? url : url && url.url;

      if (
        urlString &&
        (
          urlString.includes('/cart/add') ||
          urlString.includes('/cart/change') ||
          urlString.includes('/cart/update') ||
          urlString.includes('/cart/clear') ||
          urlString.includes('/cart.js')
        )
      ) {
        request.then(function() {
          refreshCartSoon();
        });
      }

      return request;
    };
  }

  function countPads(items) {
    const arr = (window.CW_B2G1_IDS || []).map(Number).filter(n => !Number.isNaN(n));
    const ids = new Set(arr);
    const excludedWords = /(keyboard|keycap|aviator cable)/i;

    const totalItems = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      return n + Number(i.quantity || 0);
    }, 0);

    if (ids.size === 0) return totalItems;

    const whitelistedCount = (items || []).reduce((n, i) => {
      const title = (i.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      const qualifies = ids.has(Number(i.product_id));
      return n + (qualifies ? Number(i.quantity || 0) : 0);
    }, 0);

    return whitelistedCount > 0 ? whitelistedCount : totalItems;
  }

  function resetShippingUi() {
    $('.shipping-progress').hide().removeClass('is-success');
    $('.free-shipping-badge').hide();

    $('.shipping-progress .progress-bar').show();
    $('.shipping-progress .progress-bar-value').css('width', '0%');

    $('.cw-cart-drawer-subtotals .discount-row').hide();
  }

  function renderElements(cart_value, cart) {
    resetShippingUi();

    if (!cart || !cart.items || cart.items.length === 0 || cart.item_count === 0) {
      return;
    }

    if (['european-union', 'germany', 'france', 'spain', 'italy'].includes(cw_market_handle)) {
      const cart_value_cents = cart.items_subtotal_price;
      const threshold_cents = free_shipping_threshold_eu * 100;
      const cart_value_with_shipping_cents = cart_value_cents + shipping_cost_eu;

      if (cart_value_cents < threshold_cents) {
        const money_left_cents = Math.max(threshold_cents - cart_value_with_shipping_cents, 0);
        const percent_left = Math.min((cart_value_with_shipping_cents * 100) / threshold_cents, 100);

        $('.free-shipping-badge').hide();
        $('.shipping-progress').show().removeClass('is-success');
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left_cents));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').hide();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').hide();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_eu));
      } else {
        $('.shipping-progress').hide();
        $('.free-shipping-badge').show();

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').hide();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').hide();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['australia'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_au) {
        const money_left = free_shipping_threshold_au - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_au;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_au * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['canada'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_ca) {
        const money_left = free_shipping_threshold_ca - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_ca;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_ca * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

    } else if (['poland'].includes(cw_market_handle)) {
      if (cart_value < free_shipping_threshold_pl) {
        const money_left = free_shipping_threshold_pl - cart_value;
        const percent_left = (cart_value * 100) / free_shipping_threshold_pl;

        $('.shipping-progress').show();
        $('.shipping-progress .progress-bar').show();
        $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
        $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_pl * 100));
      } else {
        $('.free-shipping-badge').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (['gb', 'united-states-2'].includes(cw_market_handle)) {
      const pads = countPads((cart && cart.items) || []);
      const $barWrap  = $('.shipping-progress');
      const $progress = $('.shipping-progress .progress-bar');
      const $fill     = $('.shipping-progress .progress-bar-value');

      $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();

      if (cw_market_handle === 'united-states-2') {
        $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
      }

      $('.free-shipping-badge').hide();

      const $host = $('.shipping-progress > div:first');
      if (!$host.find('#uk-offer-text').length) {
        $host.html('<span id="uk-offer-text"></span>');
      }

      const $text = $('#uk-offer-text');

      if (pads <= 0) {
        $text.text('🔥 Add 2 Pads To Unlock A FREE Mousepad!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '0%');
        $barWrap.removeClass('is-success');
      } else if (pads === 1) {
        $text.text('🔥 Almost There — Add 1 More Pad To Unlock Your FREE Mousepad!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '33%');
        $barWrap.removeClass('is-success');
      } else if (pads === 2) {
        $text.text('🎉 Add Any 3rd Pad — It’s FREE On Us!');
        $barWrap.show();
        $progress.show();
        $fill.css('width', '66%');
        $barWrap.removeClass('is-success');
      } else {
        $text.text('🔥 You Scored a FREE Mousepad!');
        $barWrap.show();
        $progress.hide();
        $barWrap.addClass('is-success');
      }

      $text.addClass('pulse');
      setTimeout(() => $text.removeClass('pulse'), 1500);

    } else {
      $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').show();
    }
  }

  function getCartValue(cart) {
    return parseFloat((cart.items_subtotal_price / 100.0).toFixed(2));
  }

  function refreshCart() {
    fetch('/cart.js', {
      cache: 'no-store'
    })
      .then(r => r.json())
      .then(cart => {
        renderElements(getCartValue(cart), cart);
      });
  }

  catchRequest();
  refreshCart();

  document.addEventListener('cart:updated', refreshCartSoon);
  document.addEventListener('ajaxCart:updated', refreshCartSoon);
  document.addEventListener('drawer:open', refreshCartSoon);
  document.addEventListener('cart:open', refreshCartSoon);

  const cartDrawer = document.getElementById('CartDrawer');

  if (cartDrawer) {
    const observer = new MutationObserver(function() {
      if (cartDrawer.classList.contains('drawer--is-open')) {
        refreshCartSoon();
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('click', function(e) {
    if (
      e.target.closest('.ajaxcart__qty') ||
      e.target.closest('[data-update-quantity]') ||
      e.target.closest('[data-remove]') ||
      e.target.closest('.ajaxcart__qty-adjust') ||
      e.target.closest('.js-drawer-open-cart') ||
      e.target.closest('[data-cart-trigger]') ||
      e.target.closest('.cart-link') ||
      e.target.closest('[href="/cart"]') ||
      e.target.closest('[name="add"]') ||
      e.target.closest('button[type="submit"]')
    ) {
      refreshCartSoon();
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.closest('.ajaxcart__qty')) {
      refreshCartSoon();
    }
  });
});